import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconExclamationTriangle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"exclamation-triangle, error, warning, alert"} maskId="square-filled-radius-0-stroke-1-IconExclamationTriangle"><path fillRule="evenodd" clipRule="evenodd" d="M12.0012 2.01709L1.375 19.9999H22.6274L12.0012 2.01709ZM12.5 9V14.5H11.5V9H12.5ZM12.5 16H11.5V17H12.5V16Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconExclamationTriangle;
